import { createAction, createAsyncThunk, createSlice, PrepareAction } from '@reduxjs/toolkit';
import { UserModel } from '@app/domain/UserModel';
import { persistUser, readUser } from '@app/services/localStorage.service';
import {
  activeUser,
  bulkDeleteUser,
  deleteUser,
  disableUser,
  getUserList,
  newUser,
  NewUserData,
  updateUser,
  UpdateUserData,
  UserListRequest,
} from '@app/api/users.api';

export interface UserState {
  user: UserModel | null;
  users: UserModel[] | null;
}

const initialState: UserState = {
  user: readUser(),
  users: [],
};

export const getUsers = createAsyncThunk('user/list', async (loginPayload: UserListRequest, { dispatch }) =>
  getUserList(loginPayload).then((res) => {
    dispatch(res.data);
    return res.data;
  }),
);

export const setUser = createAction<PrepareAction<UserModel>>('user/setUser', (newUser) => {
  persistUser(newUser);

  return {
    payload: newUser,
  };
});

export const doDisableUser = createAsyncThunk('user/doDisableUser', async (id: number) => disableUser(id));

export const doActiveUser = createAsyncThunk('user/doActiveUser', async (id: number) => activeUser(id));

export const doDeleteUser = createAsyncThunk('user/doDeleteUser', async (id: number) => deleteUser(id));

export const doAddUser = createAsyncThunk('user/doAddUser', async (newUserData: NewUserData) => newUser(newUserData));

export const doUpdateUser = createAsyncThunk('user/doUpdateUser', async (updateUserData: UpdateUserData) =>
  updateUser(updateUserData.id, updateUserData),
);

export const doBulkDeleteUser = createAsyncThunk('user/doBulkDeleteUser', async (ids: number[]) =>
  bulkDeleteUser(ids.join(',')),
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.users = action.payload;
    });
  },
});

export default userSlice.reducer;
